import type { Ref } from 'vue'
import { useMobileAppData, type MobileAppData } from './mobile-app-data'

const DEVICE_CREATED = 'DEVICE_CREATED'
const SHOW_QR_CODE = 'SHOW_QR_CODE'
const SIGN_OUT = 'SIGN_OUT'
const MOBILE_ACCESS_TOKEN_UNAUTHORIZED = 'MOBILE_ACCESS_TOKEN_UNAUTHORIZED'
const SHOW_ABOUT_PAGE = 'SHOW_ABOUT_PAGE'
const READY_FOR_DEEP_LINK = 'READY_FOR_DEEP_LINK'

type MobileAppMessage = {
    action: string
    deviceKey?: string
    customerId?: string
    customerName?: string
}

function postMessageCapacitor(
    mobileAppData: Ref<MobileAppData>,
    message: MobileAppMessage
) {
    if (mobileAppData.value.capacitorOrigin === null) {
        alert('Oops! We are having internal communication troubles')
        return
    }

    // Only post to known capacitor origin
    window.parent.postMessage(message, mobileAppData.value.capacitorOrigin)
}

export function usePostMessageCapacitor() {
    const mobileAppData = useMobileAppData()

    function postDeviceCreated(
        deviceKey: string,
        customerId: string,
        customerName: string
    ) {
        postMessageCapacitor(mobileAppData, {
            action: DEVICE_CREATED,
            deviceKey: deviceKey,
            customerId: customerId,
            customerName: customerName
        })
    }

    function postShowQrCode() {
        postMessageCapacitor(mobileAppData, {
            action: SHOW_QR_CODE
        })
    }

    function postSignOut() {
        postMessageCapacitor(mobileAppData, {
            action: SIGN_OUT
        })
    }

    function postShowAboutPage() {
        postMessageCapacitor(mobileAppData, {
            action: SHOW_ABOUT_PAGE
        })
    }

    function postMobileAccessTokenUnauthorized() {
        postMessageCapacitor(mobileAppData, {
            action: MOBILE_ACCESS_TOKEN_UNAUTHORIZED
        })
    }

    function postReadyForDeepLink() {
        postMessageCapacitor(mobileAppData, {
            action: READY_FOR_DEEP_LINK
        })
    }

    return {
        postDeviceCreated,
        postMobileAccessTokenUnauthorized,
        postReadyForDeepLink,
        postShowAboutPage,
        postShowQrCode,
        postSignOut
    }
}
